module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-uh-oh.7263c9cc.svg";